var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { E_QPC_REQUIRED_ELEMENT_TYPE, E_REQUIRED_ELEMENT_CHALLENGE_STATUS, } from 'src/services/cases/types';
import { E_STATUS } from 'src/shared/types';
import { flatArrays, getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { parseControlForVerification } from 'src/redux/cases/helpers/qpcConverter2';
export var mergeVerification = function (verifications) {
    return verifications
        .filter(function (verification) { return verification.results.length > 0; })
        .map(function (verification) {
        var results = verification.results, rest = __rest(verification, ["results"]);
        return __assign(__assign({}, rest), { result: results === null || results === void 0 ? void 0 : results.reduce(function (acc, curr) { return (acc.studyNumber > curr.studyNumber ? acc : curr); }) });
    });
};
export var getKYCSessionByApplicant = function (applicants, documents) {
    return applicants.map(function (applicant) { return ({
        id: applicant.id,
        sessions: documents
            .filter(function (doc) { return doc.applicantIds[0] === applicant.id; })
            .map(function (doc) { return ({ verifications: doc.verifications, proofRequirements: doc.proofRequirements }); }),
    }); });
};
// On supprime tout les elements qui sont deleted ou qui n'ont pas de sides ou de documents ou de challenge
export var dropEmptyElements = function (elements) {
    return elements
        .map(function (element) { return (__assign(__assign({}, element), { documents: element.documents.filter(function (doc) { return !(doc.deleted || doc.deleted === true); }), sides: element.sides
            .map(function (side) { return (__assign(__assign({}, side), { uploads: side.uploads.filter(function (upload) { return !(upload.deleted || upload.deleted === true); }) })); })
            .filter(function (side) { return side.uploads.length > 0; }) })); })
        .filter(function (element) {
        var sides = element.sides, challenges = element.challenges;
        return sides.filter(function (side) { return side.uploads.length > 0; }).length > 0 || challenges.length > 0;
    });
};
export var dropEmptyAcceptedProof = function (acceptedProof) {
    return acceptedProof.requiredElements.length > 0;
};
// On merge par originId les requiredElements, (concat)
export var mergeAcceptedProofOrigin = function (acceptedProofs) {
    return acceptedProofs.reduce(function (acc, curr) {
        if (acc.some(function (acceptedProof) { return acceptedProof.originId === curr.originId; })) {
            return acc
                .map(function (item) {
                return item.originId === curr.originId
                    ? __assign(__assign({}, item), { requiredElements: dropEmptyElements(__spreadArray(__spreadArray([], item.requiredElements, true), curr.requiredElements, true)) }) : item;
            })
                .filter(dropEmptyAcceptedProof);
        }
        else {
            return __spreadArray(__spreadArray([], acc, true), [__assign(__assign({}, curr), { requiredElements: dropEmptyElements(curr.requiredElements) })], false).filter(dropEmptyAcceptedProof);
        }
    }, []);
};
// On merge par originId les acceptedProof, (concat)
export var mergeSessionsOrigin = function (sessions) {
    var proofRequirements = sessions.proofRequirements, verifications = sessions.verifications;
    var proofMergedOrigin = proofRequirements.reduce(function (acc, curr) {
        if (acc.some(function (proofRequirement) { return proofRequirement.originId === curr.originId; })) {
            return acc.map(function (item) {
                return item.originId === curr.originId
                    ? __assign(__assign({}, item), { acceptedProofs: mergeAcceptedProofOrigin(__spreadArray(__spreadArray([], item.acceptedProofs, true), curr.acceptedProofs, true)) }) : item;
            });
        }
        else {
            return __spreadArray(__spreadArray([], acc, true), [__assign(__assign({}, curr), { acceptedProofs: mergeAcceptedProofOrigin(curr.acceptedProofs) })], false);
        }
    }, []);
    return {
        proofRequirements: proofMergedOrigin,
        verifications: mergeVerification(verifications),
    };
};
export var joinSessions = function (sessions) {
    return sessions.reduce(function (acc, curr) { return ({
        verifications: __spreadArray(__spreadArray([], acc.verifications, true), (curr.verifications ? curr.verifications : []), true),
        proofRequirements: __spreadArray(__spreadArray([], acc.proofRequirements, true), (curr.proofRequirements ? curr.proofRequirements : []), true),
    }); }, { verifications: [], proofRequirements: [] });
};
export var mergeSessions = function (applicantsSessions) {
    return applicantsSessions.map(function (applicantSession) { return (__assign(__assign({}, applicantSession), { sessions: mergeSessionsOrigin(joinSessions(applicantSession.sessions)) })); });
};
export var parseSessions = function (applicantsSessions) {
    return applicantsSessions.map(function (applicantSession) { return (__assign(__assign({}, applicantSession), { sessions: {
            verifications: applicantSession.sessions.verifications.map(function (verification) {
                var _a;
                return (__assign(__assign({}, verification), { assetSources: (_a = verification.assetSources) === null || _a === void 0 ? void 0 : _a.map(function (assetSource) { return ({
                        docId: assetSource.id.id,
                        assetType: assetSource.assetType,
                    }); }) }));
            }),
            proofRequirements: applicantSession.sessions.proofRequirements,
        } })); });
};
// garder la premiere vérification qui a un id identique a d'autre vérification
export var filterIdenticalVerification = function (verifications) {
    return verifications.reduce(function (acc, curr) {
        if (acc.some(function (item) { return item.id === curr.id; })) {
            return acc;
        }
        return __spreadArray(__spreadArray([], acc, true), [curr], false);
    }, []);
};
export var checkIfIsHistoryAcceptedProof = function (allAcceptedProof, acceptedProofParam) {
    var hightestStudyNumberAcceptedProof = allAcceptedProof.reduce(function (acc, acceptedProof) {
        var requiredElements = acceptedProof.requiredElements;
        var lastRequiredElement = requiredElements[requiredElements.length - 1];
        var hightestStudyNumber = lastRequiredElement.sides
            .map(function (side) { return side.uploads.reduce(function (a, b) { return (a.studyNumber > b.studyNumber ? a : b); }, { studyNumber: 0 }).studyNumber; })
            .reduce(function (a, b) { return (a > b ? a : b); }, 0);
        if (hightestStudyNumber > acc) {
            return hightestStudyNumber;
        }
        else {
            return acc;
        }
    }, 0);
    // check if current acceptedProof is a history element
    var requiredElements = acceptedProofParam.requiredElements;
    var lastRequiredElement = requiredElements[requiredElements.length - 1];
    var hightestStudyNumber = lastRequiredElement.sides
        .map(function (side) { return side.uploads.reduce(function (a, b) { return (a.studyNumber > b.studyNumber ? a : b); }, { studyNumber: 0 }).studyNumber; })
        .reduce(function (a, b) { return (a > b ? a : b); }, 0);
    return hightestStudyNumberAcceptedProof !== hightestStudyNumber;
};
// Tout les originId étant réuni on garde le dernier d'entre eux (censé etre le plus recent "studyNumber" le plus élévé)
// On garde aussi le dernier acceptedProof car on ne veut pas voir les anciennes pièces justificatives du même 'groupe' d'acceptedProof
export var mergedSameElementByLastItem = function (applicantsSessions) {
    return applicantsSessions.map(function (applicant) { return (__assign(__assign({}, applicant), { sessions: __assign(__assign({}, applicant.sessions), { verifications: filterIdenticalVerification(applicant.sessions.verifications), proofRequirements: applicant.sessions.proofRequirements.map(function (proofRequirement) { return (__assign(__assign({}, proofRequirement), { acceptedProofs: proofRequirement.acceptedProofs.map(function (acceptedProof) { return (__assign(__assign({}, acceptedProof), { isHistory: checkIfIsHistoryAcceptedProof(proofRequirement.acceptedProofs, acceptedProof), requiredElements: acceptedProof.requiredElements.reduce(function (acc, curr) {
                        if (acc.some(function (item) { return item.originId === curr.originId; })) {
                            return acc.map(function (item) { return (item.originId === curr.originId ? curr : item); });
                        }
                        return __spreadArray(__spreadArray([], acc, true), [curr], false);
                    }, []) })); }) })); }) }) })); });
};
// TODO refacto with gcpConverter
export var sortControlsListByStatus = function (a, b) {
    var _a;
    var STATUS_VALUE = (_a = {},
        _a[E_STATUS.KO] = 0,
        _a[E_STATUS.UNKNOWN] = 1,
        _a[E_STATUS.OK] = 2,
        _a);
    var mappedA = STATUS_VALUE[a.status || E_STATUS.UNKNOWN];
    var mappedB = STATUS_VALUE[b.status || E_STATUS.UNKNOWN];
    return mappedA - mappedB;
};
export var isChallengeType = function (type) {
    return (type === E_QPC_REQUIRED_ELEMENT_TYPE.LIVENESS ||
        type === E_QPC_REQUIRED_ELEMENT_TYPE.SCANID ||
        type === E_QPC_REQUIRED_ELEMENT_TYPE.DIGITAL_ID ||
        type === E_QPC_REQUIRED_ELEMENT_TYPE.OPEN_BANKING ||
        type === E_QPC_REQUIRED_ELEMENT_TYPE.NFC);
};
// Challenge have a different way to define a status, we want to cast it to E_STATUS
export var castChallengeStatus = function (challengeStatus) {
    return challengeStatus === E_REQUIRED_ELEMENT_CHALLENGE_STATUS.SUCCEEDED ? E_STATUS.OK : E_STATUS.KO;
};
export var retrieveDocumentStatus = function (requiredElement, challenge) {
    var _a;
    var machineStatus = requiredElement.machineStatus, humanStatus = requiredElement.humanStatus, type = requiredElement.type;
    var isChallenge = isChallengeType(type);
    // TODO REMOVE after SOAQ-4199 is done +3 month lifespan of old cases
    if (isChallenge && !humanStatus && !machineStatus) {
        return castChallengeStatus((_a = challenge === null || challenge === void 0 ? void 0 : challenge.result) === null || _a === void 0 ? void 0 : _a.status);
    }
    return E_STATUS[humanStatus] || E_STATUS[machineStatus] || E_STATUS.UNKNOWN;
};
export var extractDataFromElement = function (document) {
    var _a;
    if (!document) {
        return [];
    }
    // first filter faces which are not deleted and should be displayed
    var validfaces = ((_a = document === null || document === void 0 ? void 0 : document.faces) === null || _a === void 0 ? void 0 : _a.filter(function (face) { return face.deleted !== true && face.display; })) || [];
    return flatArrays(validfaces.map(function (face) { return face.fields.map(function (field) { return ({ code: field.name, values: field.values }); }); }));
};
export var parseExtractedData = function (extractedData) {
    var _a;
    var mrzValues = (_a = extractedData.find(function (data) { return data.code === 'mrz'; })) === null || _a === void 0 ? void 0 : _a.values;
    var parsedExtractedValues = extractedData.map(function (data) { return ({
        label: data.code,
        value: Array.isArray(data.values) ? data.values.join('\n') : data.values,
    }); });
    return { all: parsedExtractedValues, mrz: Array.isArray(mrzValues) ? mrzValues : [mrzValues] || null };
};
export var getKYCDescriptionForControl = function (i18n, control) {
    var _a;
    var status = control.status, code = control.code, values = control.values, template = control.template, i18nCode = control.i18nCode;
    var PARAM_REGEX = /{[0-9]{1,2}}/g;
    var kycLabel = getPropsByKeyPath(i18n.kyc, i18nCode);
    var templateValues = Array.isArray(values) ? values : [values];
    var keyPathTranslation = "kyc.document.control.label.".concat(code, ".").concat(status);
    var labelInternationalized = getPropsByKeyPath(i18n.keyValueMap, keyPathTranslation);
    var labelFallbacks = kycLabel || labelInternationalized || ((template === null || template === void 0 ? void 0 : template.length) > 0 ? template : null) || code;
    var valuesNeeded = ((_a = labelFallbacks.match(PARAM_REGEX)) === null || _a === void 0 ? void 0 : _a.length) > 0;
    if (valuesNeeded) {
        if ((templateValues === null || templateValues === void 0 ? void 0 : templateValues.length) > 0) {
            var missingValues_1 = 0;
            var labelWithValues = labelFallbacks.replace(PARAM_REGEX, function (matchedString) {
                var decapsulatedVariable = matchedString.substring(1, matchedString.length - 1);
                var variable = templateValues[decapsulatedVariable];
                if (!!variable) {
                    return variable;
                }
                else {
                    missingValues_1 = missingValues_1 + 1;
                    return '';
                }
            });
            return labelWithValues;
        }
        else {
            return code;
        }
    }
    else {
        return labelFallbacks;
    }
};
export var filterControlsByScoreType = function (document) {
    return document.controls.filter(function (control) {
        var _a;
        var documentScoreType = document.targetScoreType;
        // Maybe in the future we only want to hide them and not filter them out
        return !!!documentScoreType || (!!documentScoreType && ((_a = control.scoreTypes) === null || _a === void 0 ? void 0 : _a.indexOf(documentScoreType)) > -1);
    });
};
export var getScoreMachine = function (controls) {
    var _a, _b;
    var higherControlsWarning = ((_a = controls.find(function (doc) { return doc.status === E_STATUS.KO; })) === null || _a === void 0 ? void 0 : _a.status) ||
        ((_b = controls.find(function (doc) { return doc.status === E_STATUS.UNKNOWN; })) === null || _b === void 0 ? void 0 : _b.status) ||
        E_STATUS.OK;
    var nbOfControlsWarning = controls.filter(function (doc) { return doc.status === E_STATUS.KO; }).length +
        controls.filter(function (doc) { return doc.status === E_STATUS.UNKNOWN; }).length;
    return { status: higherControlsWarning, nbOfControls: nbOfControlsWarning };
};
export var parseRequiredElement = function (i18n, requiredElement, acceptedProof) {
    var _a, _b, _c, _d, _e;
    var isHistory = acceptedProof.isHistory;
    var id = requiredElement.id, challenges = requiredElement.challenges, documents = requiredElement.documents, label = requiredElement.label, sides = requiredElement.sides, type = requiredElement.type;
    var documentsNotDeleted = documents.filter(function (doc) { return doc.deleted !== true; });
    // As old parser we take last document (visibly is functional choice)
    var documentDisplayed = documentsNotDeleted.filter(function (doc) { return doc.faces.filter(function (face) { return face.display && face.deleted !== true; }).length > 0; });
    var lastDocument = documentDisplayed.length ? documentDisplayed[documentDisplayed.length - 1] : null;
    var allDocumentsControlsMerged = flatArrays(documentsNotDeleted.map(function (document) { return document.controls; }));
    var isChallenge = isChallengeType(type);
    // Due to structure difference between challenge and sides we need a dedicated processing
    // Define study number by challenge for liveness and scanId or by sides if other
    var docStudyNumber;
    var docControls = [];
    if (isChallenge) {
        docStudyNumber = challenges.reduce(function (a, b) { return (a.studyNumber > b.studyNumber ? a : b); }, { studyNumber: 0 }).studyNumber;
    }
    else {
        docStudyNumber = sides
            .map(function (side) { return side.uploads.reduce(function (a, b) { return (a.studyNumber > b.studyNumber ? a : b); }, { studyNumber: 0 }).studyNumber; })
            .reduce(function (a, b) { return (a > b ? a : b); }, 0);
    }
    var uploadsWithSide = sides.flatMap(function (side) {
        var _a = side.uploads, uploads = _a === void 0 ? [] : _a;
        var mostRecentStudyNumber = uploads.reduce(function (max, current) { return (current.studyNumber > max ? current.studyNumber : max); }, 0);
        return uploads
            .filter(function (upload) { return upload.studyNumber === mostRecentStudyNumber && upload.deleted !== true && Boolean(upload.downloadUrl); })
            .map(function (upload) { return [upload, side]; });
    });
    var deduplicatedUploads = uploadsWithSide.reduce(function (acc, _a) {
        var upload = _a[0], side = _a[1];
        var isDuplicate = acc.some(function (_a) {
            var item = _a[0];
            return (upload.id && item.id === upload.id) || (upload.downloadUrl && item.downloadUrl === upload.downloadUrl);
        });
        return isDuplicate ? acc : __spreadArray(__spreadArray([], acc, true), [[upload, side]], false);
    }, []);
    var sidesFiles = deduplicatedUploads.map(function (_a) {
        var upload = _a[0], side = _a[1];
        return ({
            url: upload.downloadUrl,
            name: side.label,
            id: upload.id,
        });
    });
    var lastDocumentAssets = flatArrays(lastDocument === null || lastDocument === void 0 ? void 0 : lastDocument.faces.map(function (item) {
        return item.assets.map(function (rslt) { return ({
            url: rslt.downloadUrl,
            name: rslt.assetType,
        }); });
    }));
    var mostRecentChallenge = challenges.length
        ? challenges.reduce(function (prev, current) { return (prev.studyNumber > current.studyNumber ? prev : current); })
        : null;
    var challengesFiles = ((_b = (_a = mostRecentChallenge === null || mostRecentChallenge === void 0 ? void 0 : mostRecentChallenge.result) === null || _a === void 0 ? void 0 : _a.assets) === null || _b === void 0 ? void 0 : _b.map(function (rslt) { return ({
        url: rslt.downloadUrl,
        name: rslt.assetType,
    }); })) || [];
    var docFiles = __spreadArray(__spreadArray(__spreadArray([], sidesFiles, true), lastDocumentAssets, true), challengesFiles, true).filter(function (file, index, self) {
        return index === self.findIndex(function (f) { return (file.id && f.id === file.id) || (file.url && f.url === file.url); });
    });
    var extractedData = extractDataFromElement(lastDocument);
    if (isChallenge) {
        var challengeStatus = castChallengeStatus((_c = mostRecentChallenge === null || mostRecentChallenge === void 0 ? void 0 : mostRecentChallenge.result) === null || _c === void 0 ? void 0 : _c.status);
        var controlDescription = getPropsByKeyPath(i18n, "modules.globalView.kyc.".concat(type, ".").concat(challengeStatus))
            .replace('$reason', (_d = mostRecentChallenge === null || mostRecentChallenge === void 0 ? void 0 : mostRecentChallenge.result) === null || _d === void 0 ? void 0 : _d.reason)
            .replace('$provider', (_e = mostRecentChallenge === null || mostRecentChallenge === void 0 ? void 0 : mostRecentChallenge.result) === null || _e === void 0 ? void 0 : _e.configurationName);
        docControls = [
            {
                code: 'challenge',
                description: controlDescription,
                isMRZ: false,
                status: challengeStatus,
                values: [],
                scoreTags: [],
            },
        ];
    }
    if (allDocumentsControlsMerged.length > 0) {
        var controlsMergedParsed = allDocumentsControlsMerged
            .map(function (control) {
            var isMRZ = ['document.mrzCheckDigits', 'document.mrzSyntax'].indexOf(control.code) !== -1;
            var scoreTagsParsed = control.scoreTypes
                ? Array.isArray(control.scoreTypes)
                    ? control.scoreTypes
                    : [control.scoreTypes]
                : [];
            return {
                code: control.code,
                description: getKYCDescriptionForControl(i18n, control),
                isMRZ: isMRZ,
                status: E_STATUS[control.status] || E_STATUS.UNKNOWN,
                values: [],
                scoreTags: scoreTagsParsed,
            };
        })
            .sort(sortControlsListByStatus);
        docControls = __spreadArray(__spreadArray([], docControls, true), controlsMergedParsed, true);
    }
    var docControlsFiltered = lastDocument ? filterControlsByScoreType(lastDocument) : isChallenge ? docControls : [];
    var isNoControl = docControls.length === 0;
    var scoreMachine = getScoreMachine(docControlsFiltered);
    var documentStatus = retrieveDocumentStatus(requiredElement, mostRecentChallenge);
    var allAssetsFromDocument = flatArrays(documents.map(function (doc) { return doc.faces.map(function (face) { return ({ id: face.id, assets: face.assets }); }); }));
    return {
        type: type,
        controls: {
            collection: docControls,
            targetScore: (lastDocument === null || lastDocument === void 0 ? void 0 : lastDocument.targetScoreType) || null,
        },
        files: docFiles,
        id: id,
        isHistory: isHistory,
        label: label,
        preview: '',
        machineKYC: isNoControl ? null : scoreMachine,
        nbOfFiles: docFiles.length,
        status: { value: documentStatus, isLoading: false },
        studyNumber: docStudyNumber,
        isFilesToMerge: false,
        extractedData: parseExtractedData(extractedData),
        decisionDisabled: false,
        lastDocsWithAssets: isChallenge // if challenge we merge challenge and documents assets
            ? __spreadArray([{ id: mostRecentChallenge.id, assets: mostRecentChallenge.result.assets }], allAssetsFromDocument, true) : allAssetsFromDocument || [],
    };
};
export var parseVerificationElement = function (i18n, verification) {
    var _a, _b;
    var id = verification.id, label = verification.label, type = verification.type, result = verification.result, humanStatus = verification.humanStatus, assetSources = verification.assetSources;
    var statusOfVerification = E_STATUS[humanStatus] || E_STATUS[result.status] || E_STATUS.UNKNOWN;
    var docFiles = []; //{url, name} // TODO no files in QPC ?
    var controls = parseControlForVerification(i18n, verification.result, type, verification.reason, verification.reportCodes);
    var isNoControl = controls.length === 0;
    // TODO refacto with gcpConverter
    var higherControlsWarning = ((_a = controls.find(function (doc) { return doc.status === E_STATUS.KO; })) === null || _a === void 0 ? void 0 : _a.status) ||
        ((_b = controls.find(function (doc) { return doc.status === E_STATUS.UNKNOWN; })) === null || _b === void 0 ? void 0 : _b.status) ||
        E_STATUS.OK;
    // TODO refacto with gcpConverter
    var nbOfControlsWarning = controls.filter(function (doc) { return doc.status === E_STATUS.KO; }).length +
        controls.filter(function (doc) { return doc.status === E_STATUS.UNKNOWN; }).length;
    return {
        controls: {
            collection: controls,
            targetScore: null,
        },
        id: id,
        isHistory: false,
        files: docFiles,
        assetSources: assetSources,
        label: label,
        type: type,
        preview: '',
        nbOfFiles: docFiles.length,
        status: { value: statusOfVerification, isLoading: false },
        studyNumber: result.studyNumber,
        isFilesToMerge: false,
        machineKYC: isNoControl ? null : { status: higherControlsWarning, nbOfControls: nbOfControlsWarning },
        extractedData: { all: [], mrz: null },
        decisionDisabled: false,
    };
};
export var enhanceVerificationWithProofFile = function (proofs, verification) {
    var _a;
    if (verification.type !== 'facematch') {
        var type = verification.type, rest = __rest(verification, ["type"]);
        return rest;
    }
    else {
        var files_1 = [];
        (_a = verification.assetSources) === null || _a === void 0 ? void 0 : _a.forEach(function (assetSource) {
            var _a, _b, _c;
            var docs = (_a = proofs.find(function (proof) {
                return proof.lastDocsWithAssets.find(function (doc) { return doc.id === assetSource.docId; });
            })) === null || _a === void 0 ? void 0 : _a.lastDocsWithAssets;
            if (docs) {
                var asset = (_c = (_b = docs
                    .find(function (doc) { return doc.id === assetSource.docId; })) === null || _b === void 0 ? void 0 : _b.assets) === null || _c === void 0 ? void 0 : _c.find(function (asset) { return asset.assetType === assetSource.assetType; });
                if (asset) {
                    files_1.push({ url: asset.downloadUrl, name: asset.assetType });
                }
            }
        });
        return __assign(__assign({}, verification), { files: files_1, nbOfFiles: 1, isFilesToMerge: true });
    }
};
export var assertChallengeIsFinished = function (challenge) { var _a; return !!((_a = challenge.result) === null || _a === void 0 ? void 0 : _a.status); };
export var removeChallengeWhichIsNotFinished = function (requiredElements) {
    return requiredElements.filter(function (requiredElement) {
        var _a;
        var challenges = requiredElement.challenges, type = requiredElement.type;
        var isChallenge = isChallengeType(type);
        var mostRecentChallenge = challenges.length
            ? challenges.reduce(function (prev, current) { return (prev.studyNumber > current.studyNumber ? prev : current); })
            : null;
        if (isChallenge) {
            var challengeStatus = (_a = mostRecentChallenge.result) === null || _a === void 0 ? void 0 : _a.status;
            return (assertChallengeIsFinished(mostRecentChallenge) &&
                (challengeStatus === E_REQUIRED_ELEMENT_CHALLENGE_STATUS.DISCONNECTED ||
                    challengeStatus === E_REQUIRED_ELEMENT_CHALLENGE_STATUS.FAILED ||
                    challengeStatus === E_REQUIRED_ELEMENT_CHALLENGE_STATUS.SUCCEEDED ||
                    challengeStatus === E_REQUIRED_ELEMENT_CHALLENGE_STATUS.TIMED_OUT));
        }
        return true;
    });
};
// On retire la notion de required, accepted, element et on recupere plus que des proofs avec de la data
// Et on garde uniquement les acceptedProof les plus récent pour ne pas revoir les anciennes pièces uploader du meme 'groupe'
export var reduceToDesiredElement = function (i18n, applicantsSessions) {
    return applicantsSessions.map(function (sessionsByApplicant) {
        var proofs = flatArrays(sessionsByApplicant.sessions.proofRequirements.map(function (proofRequirement) {
            return proofRequirement.acceptedProofs.map(function (acceptedProof) {
                var requiredElementsFiltered = removeChallengeWhichIsNotFinished(acceptedProof.requiredElements);
                return requiredElementsFiltered.map(function (requiredElement) {
                    return parseRequiredElement(i18n, requiredElement, acceptedProof);
                });
            });
        }));
        var verifications = sessionsByApplicant.sessions.verifications.map(function (verification) {
            return enhanceVerificationWithProofFile(proofs, parseVerificationElement(i18n, verification));
        });
        return __assign(__assign({}, sessionsByApplicant), { sessions: {
                proofs: proofs,
                verifications: verifications,
            } });
    });
};
export var parseQPCCaseDetailsKYC = function (i18n, applicants, documents, kycVerifications, studyElements) {
    if (!documents || documents.length < 1) {
        console.error('An error occurred : During QPC data conversion no documents provided');
        return {};
    }
    // Filter sessions by applicant
    var applicantsKYC = getKYCSessionByApplicant(applicants, documents);
    // Merge same originId, drop empty elements like deleted, no upload also no document and no challenges
    var applicantsKYCMerged = mergeSessions(applicantsKYC);
    // remove useless data from verification and parse verification to desired structure
    var applicantsKYCParsed = parseSessions(applicantsKYCMerged);
    // All same element are filter, we keep only last item, because it's the last item uploaded
    var kycMergedSameElementByLastItem = mergedSameElementByLastItem(applicantsKYCParsed);
    // Remove all layout of data to keep only element and parse them to desired structure
    var sessionsOnlyCollectionOfDocument = reduceToDesiredElement(i18n, kycMergedSameElementByLastItem);
    // Join proof and verification whose under same structure now and transform array to an object with applicantId as key
    var sessionJoinUnderOneCollection = sessionsOnlyCollectionOfDocument.reduce(function (acc, applicantSession) {
        var _a;
        var accDocumentsOfApplicant = acc[applicantSession.id] ? acc[applicantSession.id].documents : [];
        return __assign(__assign({}, acc), (_a = {}, _a[applicantSession.id] = __assign(__assign({}, acc[applicantSession.id]), { documents: __spreadArray(__spreadArray(__spreadArray([], accDocumentsOfApplicant, true), applicantSession.sessions.proofs.filter(function (proof) {
                return studyElements.some(function (item) { return item.elementId.id === proof.id; });
            }), true), applicantSession.sessions.verifications.filter(function (proof) {
                return studyElements.some(function (item) { return item.elementId.id === proof.id; });
            }), true) }), _a));
    }, {});
    return sessionJoinUnderOneCollection;
};
